export const MaterialName = "VEC_ASWS_092";
export const SizeCode = "VEC_BGR_092";

export const Coating = "VEC_BSCH_092";
export const Accuracy = "VEC_GEN_092";
export const Preload = "VEC_VSP_092";
export const GreasingPerGreaseGroup = "VEC_BLT_092";

export const MountingHoleType = "VEC_SBF_092";
export const ClosingPlugs = "VEC_SKA_093";

export const RailLocatingFaceSegment1 = "VEC_S1_ANS_092";
export const RailLocatingFaceSegment2 = "VEC_S2_ANS_092";
export const CarriageLocatingFaceSegment1 = "VEC_S1_ANW_092";
export const CarriageLocatingFaceSegment2 = "VEC_S2_ANW_092";

export const DesignType_Series = "VB_MKB_092";
export const DesignType_SizeCode = "VB_BGR_092";
export const DesignType_Version = "VB_VER_092";

export const GuidewayLength = "VEC_KWL_093";
export const GuidewayLengthMin = "VEC_LMIN_093";
export const GuidewayLengthMax = "VEC_LAMAX_093";

export const AL = "VEC_AAL_093";
export const AR = "VEC_AAR_093";
export const AlarMinRecommended = "VEC_ALMIN_093";
export const AlarMaxRecommended = "VEC_ALMAX_093";
export const AlarHardMax = "VJL_091";

export const PartSizing = "VEC_VST_093"; // Possible values: No parts, automatic split, manual split
export const PartAmount = "VEC_TLA_093";

export const PartOneLength = "TODO";
export const PartTwoLength = "TODO";
export const PartThreeLength = "TODO";
export const PartFourLength = "TODO";
export const PartFiveLength = "TODO";

export const ReferenceCarriageDesign = "VEC_WAU1_092";
